import { render, staticRenderFns } from "./productAttr.vue?vue&type=template&id=709a4e7b&scoped=true&"
import script from "./productAttr.vue?vue&type=script&lang=js&"
export * from "./productAttr.vue?vue&type=script&lang=js&"
import style0 from "./productAttr.vue?vue&type=style&index=0&id=709a4e7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709a4e7b",
  null
  
)

export default component.exports